import { render, staticRenderFns } from "./ClientesList.vue?vue&type=template&id=21b1d5f4&scoped=true&"
import script from "./ClientesList.vue?vue&type=script&lang=js&"
export * from "./ClientesList.vue?vue&type=script&lang=js&"
import style0 from "./ClientesList.vue?vue&type=style&index=0&id=21b1d5f4&lang=scss&scoped=true&"
import style1 from "./ClientesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b1d5f4",
  null
  
)

export default component.exports